import { render, staticRenderFns } from "./TestOne.vue?vue&type=template&id=3c493ad2&scoped=true"
import script from "./TestOne.vue?vue&type=script&lang=js"
export * from "./TestOne.vue?vue&type=script&lang=js"
import style0 from "./TestOne.vue?vue&type=style&index=0&id=3c493ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c493ad2",
  null
  
)

export default component.exports